<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>ໂປຣໂມຊັນພິເສດສໍາລັບລູກຄ້າ</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="ຊອກຫາ" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900">
          <v-btn slot="activator" color="primary" dark class="mb-2">ເພີ່ມ</v-btn>
          <v-card>
            <v-card-title>
            <span class="headline fontLao">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap class="fontLao">
                  <v-flex xs12 sm12 md12>
                    <v-radio-group v-model="selectftpro" row>
                      <v-radio label="Stock number" value="stockno"></v-radio>
                      <v-radio label="Barcode" value="bar"></v-radio>
                      <v-radio label="Product name" value="name"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 sm12 md12 >
                    <v-autocomplete
                      v-model="mdpro"
                      :items="itemspro"
                      :loading="isLoadingpro"
                      @change="chpro"
                      chips
                      clearable
                      cache-items
                      hide-no-data
                      hide-details
                      hide-selected
                      open-on-clear
                      :item-text="selectftpro"
                      item-value="id"
                      label="Stock number, Barcode, Product name"
                      solo
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, selected }"
                      >
                        <v-chip
                          :selected="selected"
                          color="primary"
                          class="white--text"
                        >
                          <v-icon left>mdi-coin</v-icon>
                          <span v-text="item.name + ' - ( ລາຄາ ' + item.price +' )'"> <span v-if="item.cname" v-text="' - ' + item.cname"></span></span>
                        </v-chip>
                      </template>
                      <template
                        slot="item"
                        slot-scope="{ item }"
                      >
                        <v-list-tile-avatar
                          color="primary"
                          class="headline font-weight-light white--text"
                        >
                          {{ item.name.charAt(0) }}
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-text="item.name + ' - ( ລາຄາ ' + item.price +' )'"></v-list-tile-title>
                          <v-list-tile-sub-title v-text="item.cname"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.price" type="number" min=1 label="ລາຄາ"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer >
              <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table :headers="headers" :items="mydata" :search="search" :rows-per-page-items=[10,20,50,100,500] class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.stockno }}</td>
          <td>{{ props.item.bar }}</td>
          <td>{{ props.item.cname }}</td>
          <td>{{ props.item.sname }}</td>
          <td>{{ props.item.un }}</td>
          <td>{{ _P(props.item.oprice) }}</td>
          <td>{{ _P(props.item.price) }}</td>
          <td class="text-xs-center px-0">
            <v-icon small @click="gotopageCustomProductPriceCount(props.item)" >shopping_cart</v-icon>
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> 
            <v-icon small @click="deleteItem(props.item)" > delete </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
  export default {
    name:'customprodcutprice',
    data: () => ({
      selectftpro: 'stockno',
      isLoadingpro: false,
      itemspro: [],
      mdpro: null,
      searchpro: null,
      dialog: false,
      search: '',
      headers: [
        {text: 'ຊື່ສີນຄ້າ', align: 'left', sortable: true, value: 'name'},
        {text: 'Stock no ', value: 'stockno'  ,align: 'left'},
        {text: 'Barcode', value: 'bar'  ,align: 'left'},
        {text: 'ປະເພດສີນຄ້າ', value: 'cname' ,align: 'left'},
        {text: 'ຜູ້ສະໜອງ', value: 'sname'  ,align: 'left'},
        {text: 'ຫົວໜ່ວຍ', value: 'un'  ,align: 'left'},
        {text: 'ລາຄາສິນຄ້າ', value: 'oprice' ,align: 'left'},
        {text: 'ລາຄາຂາຍໃຫ້ລູກຄ້າ', value: 'price' ,align: 'left'},
        {text: 'ການເຄື່ອນໄຫວ', value: 'action', sortable: false,align: 'center'}
      ],
      mydata: [],
      editedIndex: -1,
      editedItem: {
        product: null,
        price: 1,
        stt:1
      },
      defaultItem: {
        product: null,
        price: 1,
        stt:1
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'ເພີ່ມ' : 'ແກ້ໄຂ'
      }
    },
    watch: {
      searchpro () {
        this.initializescpd()
      },
      dialog (val) {
        if (val) {
          this.initializescpd()
        }
        val || this.close()
      }
    },
    created () {
      this.initialize()
    },
    methods: {
    _P (value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    chpro (id) {
      if (this.itemspro.length >= 1) {
        if(id != null)
        this.editedItem.product = db.collection('products').doc(id)
      }
    },
    initialize () {
      let tdata=[];
      let ref = db.collection('customer').doc(this.$route.params.id).collection('products').where("stt","==",1).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let tmpdata =doc.data();
          tmpdata.id =doc.id;
          tmpdata.price = doc.data().price;
          db.collection('products').doc(tmpdata.product.id).get().then(async doc => {
              tmpdata.name = doc.data().name;
              tmpdata.stockno = doc.data().stockno;
              tmpdata.bar = doc.data().bar;
              tmpdata.un = doc.data().un;
              tmpdata.oprice = doc.data().price;
              if(doc.data().sid) {
                await db.collection('suppliers').doc(doc.data().sid).get().then(doc => {
                  if (doc.exists) {
                  tmpdata.sname = doc.data().name;

                  } else {
                  console.log("No such document!");
                  }
                }).catch(function(error) {
                  console.log("Error getting document:", error);
                })
              }
              if(doc.data().cid){
                await db.collection('categories').doc(doc.data().cid).get().then(function(doc) {
                  if (doc.exists) {
                    tmpdata.cname =doc.data().name;
                  } else {
                    console.log("No such document!");
                  }
                }).catch(function(error) {
                  console.log("Error getting document:", error);
                });
              }
              tdata.push(tmpdata)
          }).catch(err => {
            console.log('Error getting documents', err)
          })
        });
        this.mydata=tdata;
      })
      .catch(err => {
        console.log('Error getting documents', err);
      });
    },
    initializescpd () {
      // Items have already been loaded
      if (this.itemspro.length > 0) return
      this.isLoadingpro = true
      let tdata=[];
      db.collection("products").where("stt","==",1).get().then(snapshot => {
        snapshot.forEach(async doc => {
          let tmpdata =doc.data();
          tmpdata.id =doc.id;
          if (doc.data().sid) {
            await db.collection("suppliers").doc(doc.data().sid).get().then(doc => {
              if (doc.exists) {
                tmpdata.sname = doc.data().name;
              }
            })
          }
          if (doc.data().cid) {
            await db.collection("categories").doc(doc.data().cid).get().then(function(doc) {
              if (doc.exists) {
                tmpdata.cname =doc.data().name;
              }
            })
          }
          tdata.push(tmpdata)
        })
        this.itemspro = tdata
      }).finally(() => (this.isLoadingpro = false))
    },
    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.initializescpd()
      this.mdpro = this.editedItem.product.id
      this.dialog = true
      console.log(item)
    },
    deleteItem (item) {
      const index = this.mydata.indexOf(item)
      if ( confirm('Are you sure you want to delete this item ('+item.name+' )?')) {
        db.collection('customer').doc(this.$route.params.id).collection('products').doc(item.id).update({stt:0})
        this.mydata.splice(index, 1)
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.itemspro = []
        this.mdpro = null
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        this.editedItem.price =parseFloat(this.editedItem.price)
        console.log(this.editedItem)
        db.collection('customer').doc(this.$route.params.id).collection('products').doc(id).update(
          {
            price: this.editedItem.price,
            product:this.editedItem.product,
            qty:this.editedItem.qty,
          }
        )
      } else {
        this.editedItem.price =parseFloat(this.editedItem.price)
        db.collection('customer').doc(this.$route.params.id).collection('products').add(this.editedItem)
      }
      this.initialize()
      this.close()
    },
    gotopageCustomProductPriceCount (item) {
      this.$router.push({ name: 'CustomProductPriceCount', params: { id:this.$route.params.id, proid:item.id  }})
    }
  }
}
</script>

<style>
.fontLao{
font-family: phetsarath ot !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomProductPrice.vue